import type { DynamicClient } from '../../../../../client/types/DynamicClient';
import { getLastKnownNetworkRegistry } from '../../../networks/lastKnownNetworkRegistry/getLastKnownNetworkRegistry/getLastKnownNetworkRegistry';
import type { WalletProvider } from '../../walletProvider.types';

type SwitchActiveNetworkInLastKnownRegistry = (args: {
  client: DynamicClient;
  networkId: string;
  walletProviderKey: string;
}) => ReturnType<NonNullable<WalletProvider['switchActiveNetwork']>>;

export const switchActiveNetworkInLastKnownRegistry: SwitchActiveNetworkInLastKnownRegistry =
  async ({ client, networkId, walletProviderKey }) => {
    const networkRegistry = getLastKnownNetworkRegistry(client);

    await networkRegistry.setNetworkId({
      networkId,
      walletProviderKey,
    });
  };
